function initialisePrintworxMOQ() {
  const moqContainer = document.getElementById('PrintworxMOQ');
  if (!moqContainer) return;

  const moq = parseInt(moqContainer.dataset.moq, 10);
  if (!moq || moq <= 1) return;

  const quantityInput = document.querySelector('quantity-input input.quantity__input');
  if (!quantityInput) return;

  // Prevent attaching listeners more than once
  if (quantityInput.dataset.printworxMoqBound === 'true') {
    return;
  }

  quantityInput.dataset.printworxMoqBound = 'true';

  function enforceMOQ() {
    const value = parseInt(quantityInput.value, 10);

    if (isNaN(value) || value < moq) {
      quantityInput.value = moq;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  quantityInput.min = moq;
  enforceMOQ();

  quantityInput.addEventListener('change', enforceMOQ);
  quantityInput.addEventListener('blur', enforceMOQ);
}

// Initial page load
document.addEventListener('DOMContentLoaded', initialisePrintworxMOQ);

// Watch for Dawn replacing the product HTML
const observer = new MutationObserver(() => {
  initialisePrintworxMOQ();
});

document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('product-info');

  if (productInfo) {
    observer.observe(productInfo, {
      childList: true,
      subtree: true
    });
  }
});